import React from "react";
import {Redirect} from 'react-router';
import api from '../../api/Api'
import {NavLink} from 'react-router-dom';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Grid from "@material-ui/core/Grid";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import Tooltip from "@material-ui/core/Tooltip";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import Business from "@material-ui/icons/Business";
import Loader from '../../components/Loader'
import {mappingUI, dashboardRouter} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
import {cardTitle} from "assets/jss/material-dashboard-pro-react.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import TagsInput from "react-tagsinput";
var serviceArray = [];

function getServices(services) {
    services.forEach(function (obj) {
        return serviceArray.push(obj.category);
    })
}


class Clinics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            open: true,
            element: "",
            api_status: "",
            read: false,
            alert: null,
            clickedId: "",
            redirect: false,
            redirectOne: false,
            redirectAdd: false,
            loading: true,
            selectedClinicId: "",
            clinicList: null
        };
    }

    componentDidMount() {
        this.CallReadApi();

    }

    getServices(services) {
        services.forEach(function (obj) {
            return serviceArray.push(obj.category);
        })
    }

    render() {
        const {classes} = this.props;
        const {data, clinicList} = this.state;
        if (this.state.clinicList)
            return (
                <div>

                    {this.state.alert}

                    <Grid container>
                        { mappingUI(Permissions.AddClinic) ? <GridItem xs={12} sm={12} md={2}>
                            <NavLink to={dashboardRouter("/clinic/addClinic")}>
                                <Button block color="warning">
                                    <Icon>add</Icon>
                                    <span style={{paddingLeft: 10}}>ADD NEW</span>
                                </Button>
                            </NavLink>
                        </GridItem> : null}
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <Business style={{marginTop: 10}}/>
                                            </GridItem>
                                            <GridItem>
                                                <h4>Clinics</h4>
                                                <p>
                                                    List of all Clinics
                                                </p>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={clinicList}
                                        filterable

                                        defaultFilterMethod={(filter, row) =>
                                        String(row[filter.id]) === filter.value}
                                        columns={[
                                            {
                                                columns: [
                                                    {
                                                        Header: "Name",
                                                        accessor: "clinic_name",
                                                        Cell: ({index}) =>
                                                            ( <div>
                                                                    <p><NavLink
                                                                        to={dashboardRouter(`/clinic/oneClinic/${clinicList[index].clinic_id}`)}>{clinicList[index].clinic_name}</NavLink>
                                                                    </p>
                                                                </div>
                                                            ),
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["clinic_name"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Master",
                                                        id: "clinic_master_name",
                                                        accessor: "clinic_master_name",
                                                        Cell: ({index}) =>
                                                            ( <div>
                                                                    <p>{clinicList[index].clinic_master_name ? clinicList[index].clinic_master_name : 'No Clinic Master!' }</p>
                                                                </div>
                                                            ),
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["clinic_master_name"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Locality",
                                                        accessor: "locality",
                                                        Cell: ({index}) =>
                                                            ( <div>
                                                                    <p>{clinicList[index].locality}</p>
                                                                </div>
                                                            ),
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["locality"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Contact",
                                                        accessor: "clinic_contact",
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["clinic_contact"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Categories",
                                                        accessor: "categories",
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["clinic_categories"]}),
                                                        Cell: ({index}) => ( <div>

                                                                <GridItem>
                                                                    <TagsInput
                                                                        value={clinicList[index].clinic_categories}
                                                                        onChange={this.handleTags}
                                                                        disabled
                                                                        tagProps={{className: "react-tagsinput-tag warning"}}
                                                                        inputProps={{placeholder: ""}}
                                                                    />
                                                                </GridItem>
                                                            </div>
                                                        )

                                                        ,
                                                        filterable: false,
                                                        sortable: false
                                                    },
                                                    {
                                                        Header: 'Actions',
                                                        id: 'request_state',
                                                        filterable: false,
                                                        sortable: false,
                                                        maxWidth: 160,
                                                        Cell: ({index}) =>
                                                            ( <div>
                                                                    {mappingUI(Permissions.ViewClinic) ? <NavLink
                                                                        to={dashboardRouter(`/clinic/oneClinic/${clinicList[index].clinic_id}`)}>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="View"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}>
                                                                            <Button type="button" color="info"
                                                                                    style={{
                                                                                        padding: 8,
                                                                                        marginLeft: '10%'
                                                                                    }}>
                                                                                <Icon style={{fontSize: 20}}>info</Icon>
                                                                            </Button></Tooltip>
                                                                    </NavLink> : null}
                                                                    {mappingUI(Permissions.UpdateClinic) ? <NavLink
                                                                        to={dashboardRouter(`/clinic/updateClinic/${clinicList[index].clinic_id}`)}>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Edit"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}>
                                                                            <Button type="button" color="success"
                                                                                    style={{
                                                                                        padding: 8,
                                                                                        marginLeft: '5%'
                                                                                    }}
                                                                                // onClick={this.RouteToUpdate(data[index].clinic_id)}
                                                                            >
                                                                                <Icon style={{fontSize: 20}}>edit</Icon>
                                                                            </Button></Tooltip></NavLink> : null}
                                                                    {mappingUI(Permissions.DeleteClinic) ?
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Remove"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}>
                                                                            <Button type="button" color="danger"
                                                                                    style={{
                                                                                        padding: 8,
                                                                                        marginLeft: '5%'
                                                                                    }}
                                                                                    onClick={() => this.CreateAlert(data[index].clinic_id)}>
                                                                                <Icon
                                                                                    style={{fontSize: 20}}>close</Icon>
                                                                            </Button></Tooltip> : null}
                                                                </div>
                                                            )
                                                    }
                                                ]
                                            }
                                        ]}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    CallReadApi = () => {
        api.listClinics().then(json => {
            this.setState({data: json.data.data}, () => {
                this.setState({
                    clinicList: this.state.data.map(item => {
                        return {
                            clinic_name: item.clinic_name,
                            clinic_id: item.clinic_id,
                            clinic_master_name: item.clinic_parentclinicid.name,
                            locality: item.clinic_address.locality, clinic_contact: item.clinic_contact,
                            clinic_categories: item.clinic_categories.map(function (obj) {
                                return obj.category;
                            })


                        }
                    })
                })
            })
        });
    };

    successDelete() {
        this.setState({
            alert: (
                <SweetAlert
                    success
                    style={{display: "block", marginTop: "-100px"}}
                    title="Deleted!"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                >
                </SweetAlert>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"clinic_master_id": id};
        api.deleteClinicById(id)
            .then(json => {
            });

    }

    hideAlert() {
        this.setState({
            alert: null
        });
        window.location.reload()

    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{display: "block", marginTop: "-100px"}}
                    title="Are you sure?"
                    onConfirm={() => {
                        this.successDelete();
                            this.deleteRecord(id)
                    }}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                    cancelBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.danger
                    }
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    You will not be able to recover this clinic!
                </SweetAlert>
            )
        });
    }


}

export default withStyles(sweetAlertStyle)(Clinics);



// WEBPACK FOOTER //
// ./src/views/Clinics/Clinics.jsx